module.exports = __webpack_public_path__ + "static/img/hatchback-blue.b0ac596.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hatchback-blue.svg
// module id = uh4U
// module chunks = 82